
import Api from '../../../helpers/Api';

// ACTION  TYPE
export const DATA_LIST_YEARS = 'DATA_LIST_YEARS';
const setListYears = (listYears) => ({
    type: DATA_LIST_YEARS,
    listYears,
});


export const DATA_LIST_MUSICS = 'DATA_LIST_MUSICS';
const setListMusics = (listMusics, year) => ({
    type: DATA_LIST_MUSICS,
    listMusics,
    year,
});

export const CLEAR_LIST_MUSICS = 'CLEAR_LIST_MUSICS';
const clearListMusics = () => ({
    type: CLEAR_LIST_MUSICS,
});

export const SET_NOT_FOUND = 'SET_NOT_FOUND';
const setNotFound = (notFound) => ({
    type: SET_NOT_FOUND,
    notFound,
});
// ACTION

const _getListYearsIfNeeded = () => (dispatch, getState) => {
    const listYears = getState().top100.listYears;

    if (listYears.length === 0) {
        return Api.progressGet(dispatch, '/api/v1/top100/getListYears').then((json) => {
            if (json.status === 'success') {
                dispatch(setListYears(json.data));
            } else {
                throw JSON.stringify(json);
            }
        }).catch((error) => {
            // eslint-disable-next-line no-console
            console.log('getListYears-> got error: ', error);
        });
    }

    return Promise.resolve(1);
};


// @TODO: check if a year that is passed exists
export const getListMusicsIfNeeded = (year) => (dispatch, getState) => dispatch(_getListYearsIfNeeded()).then(() => {
    // check if year changed, and only fetch if changed
    if (!year) {
        // if no year was given get the most recent
        // @TODO do this check in the calling function already?
        // @TODO first check if listYears really exists?
        // eslint-disable-next-line no-param-reassign
        year = getState().top100.listYears[0].tx_ano;
    }

    const currentYear = getState().top100.currentYear;

    if (currentYear !== year) {
        dispatch(clearListMusics());

        dispatch(setNotFound(false));

        return Api.progressGet(dispatch, `/api/v1/top100/getListMusics/${year}`)
            .then((json) => {
                if (json.status === 'success') {
                    dispatch(setListMusics(json.data, year));
                } else {
                    dispatch(setNotFound(true));

                    throw JSON.stringify(json);
                }
            });
    }

    return Promise.resolve(1);
}).catch((error) => {
    // eslint-disable-next-line no-console
    console.log(`getListMusics-> got error: ${error}`);
});
